import { Hook } from '~/hooks/Hook'

export async function pushEventTo<T>(hook: Hook, event: string, payload: object): Promise<T> {
  return new Promise((resolve) => {
    hook.pushEventTo(hook.el, event, payload, (response) => {
      resolve(response)
    })
  })
}
